import Component from "@glimmer/component";
import { service } from "@ember/service";
import Select, { Option } from "glesys-controlpanel/components/select";
import IconsCloud from "glesys-controlpanel/components/icons/cloud";
import IconsMoon from "glesys-controlpanel/components/icons/moon";
import IconsSun from "glesys-controlpanel/components/icons/sun";
import { t } from "ember-intl";
import { on } from "@ember/modifier";

export default class ThemeSelector extends Component {
  @service theme;

  get currentIcon() {
    switch (this.theme.current) {
      case "auto":
        return IconsCloud;
      case "dark":
        return IconsMoon;
      case "light":
        return IconsSun;
      default:
        return IconsCloud;
    }
  }

  onChange = (event) => {
    const data = new FormData(event.currentTarget);
    this.theme.activate(data.get("theme"));
  };

  <template>
    <form data-test-theme-selector ...attributes {{on "change" this.onChange}}>
      <Select
        class="border-0 p-0 bg-gray-200 text-black rounded-full"
        aria-label={{t "component.theme-selector.aria-label"}}
        name="theme"
        @value={{this.theme.current}}
        @chevron={{false}}
      >
        <:selectedcontent>
          <span class="flex items-center size-6 p-0.5" data-test-selected-theme={{this.theme.current}}>
            {{component this.currentIcon}}
          </span>
        </:selectedcontent>
        <:default>
          <Option value="auto">
            <span class="flex items-center">
              <span class="mr-1"><IconsCloud /></span>
              {{t "component.theme-selector.auto"}}
            </span>
          </Option>
          <Option value="dark">
            <span class="flex items-center">
              <span class="mr-1"><IconsMoon /></span>
              {{t "component.theme-selector.dark"}}
            </span>
          </Option>
          <Option value="light">
            <span class="flex items-center">
              <span class="mr-1"><IconsSun /></span>
              {{t "component.theme-selector.light"}}
            </span>
          </Option>
        </:default>
      </Select>
    </form>
  </template>
}
